export { default } from './ConfettiBackground';
